import { render, staticRenderFns } from "./menuSwitchShortcut.vue?vue&type=template&id=1232a55b&scoped=true&"
import script from "./menuSwitchShortcut.vue?vue&type=script&lang=js&"
export * from "./menuSwitchShortcut.vue?vue&type=script&lang=js&"
import style0 from "./menuSwitchShortcut.vue?vue&type=style&index=0&id=1232a55b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1232a55b",
  null
  
)

export default component.exports